import React, { useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { bulkUpdateCrmTags } from '../config/api';

const CrmBulkTagDialog = ({ leadIds, tagOptions, onClose, onSaved }) => {
  const [action, setAction] = useState('add');
  const [selectedTag, setSelectedTag] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    const tag = selectedTag?.value?.trim();
    if (!tag) {
      setError('Select or enter a tag.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      const response = await bulkUpdateCrmTags(leadIds, action, tag);
      if (onSaved) await onSaved(response?.data || response);
      onClose();
    } catch (err) {
      setError(err.message || `Could not ${action} the tag.`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '520px' }}>
        <form onSubmit={submit}>
          <div className="modal-header">
            <h3>Update Tags</h3>
            <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
          </div>
          <div className="modal-body">
            <p className="crm-muted">
              Add or remove one tag on {leadIds.length} selected Lead{leadIds.length === 1 ? '' : 's'}.
            </p>
            <div className="form-group">
              <label className="form-label" htmlFor="crm-bulk-tag-action">Action</label>
              <select
                id="crm-bulk-tag-action"
                className="form-control"
                value={action}
                onChange={(event) => {
                  setAction(event.target.value);
                  setError('');
                }}
                disabled={saving}
              >
                <option value="add">Add tag</option>
                <option value="remove">Remove tag</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="crm-bulk-tag-select">Tag</label>
              <CreatableSelect
                inputId="crm-bulk-tag-select"
                options={tagOptions}
                value={selectedTag}
                onChange={(option) => {
                  setSelectedTag(option);
                  setError('');
                }}
                placeholder="Select or enter a tag"
                formatCreateLabel={(input) => `Use tag “${input}”`}
                isClearable
                isDisabled={saving}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 1100 }) }}
                autoFocus
              />
            </div>
            {error && <div className="crm-form-error">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={saving || !selectedTag}>
              {saving ? 'Updating…' : action === 'add' ? 'Add Tag' : 'Remove Tag'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrmBulkTagDialog;
